const AUD_MONEY = {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
}

/** Format AUD amounts already stored in dollars (e.g. session turnover, slot analysis). */
export function formatGamingMoney(value) {
  if (value == null || value === '') return '—'
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('en-AU', AUD_MONEY).format(n)
}

/** Format raw meter counter units (cents) as AUD with decimal places. */
export function formatMeterCents(value) {
  if (value == null || value === '') return '—'
  const n = Number(value)
  if (!Number.isFinite(n)) return '—'
  return new Intl.NumberFormat('en-AU', AUD_MONEY).format(n / 100)
}

/** Numeric meter counter units → dollars (for charts/exports). */
export function meterCentsToDollars(value) {
  const n = Number(value)
  if (!Number.isFinite(n)) return null
  return n / 100
}
